/**
 * 获取地图的公共方法
 **/
export default {
    methods: {

        /**
         * 获取地图，地图加载完成后触发Promise.then
         * @param id
         */
        resolveMap(id: string = 'map') {
            return new Promise((resolve: any, reject: any) => {
                const container: any = (this as any).container;
                const mapShare: any = container.resolve('mapShare');
                const mapWapper: any = mapShare.getMapWapper();
                if (mapWapper && mapWapper.initialized()) {
                    resolve(mapWapper);
                } else {
                    const notify = container.resolve('notify');
                    notify.on(`map-ready-${id}`, (mapSharePrams: any) => {
                        resolve(mapSharePrams.getMapWapper());
                    }, this);
                }
            });
        },
    },
};
